export default __webpack_public_path__ + "static/media/XL.570dc4f9.png";